import React from 'react';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';

import notFound from '../../404.png';
import Page from '../../components/Page';

function NoMatchPage() {
  return (
    <Page>
      <HStack alignItems="center" h="600px" justify="center" w="100%">
        <Flex direction="column" h="300px" justify="center" textAlign="left" w="35%">
          <Text textStyle="displayXs600">
            Something is wrong.
          </Text>
          <Text color="greyScale.400" mt={8}>
            We couldn&apos;t find the page you&apos;re looking for. Double check your URL or email us at
            {' '}
            <span
              style={{ fontWeight: '600' }}
            >
              support@pinsadvantage.com
            </span>
            .
          </Text>
        </Flex>
        <Box>
          <img alt="Page Not Found" src={notFound} />
        </Box>
      </HStack>
    </Page>
  );
}

export default NoMatchPage;
